export default class Vector3
{
    constructor(x : number, y : number, z : number)
    {
        this.x = x;
        this.y = y;
        this.z = z;
    }

    public x : number;
    public y : number;
    public z : number;

    public toString() : string
    {
		return `{${this.x}, ${this.y}, ${this.z}}`;
    }
}